import { render, staticRenderFns } from "./ScrapList.vue?vue&type=template&id=0729ed14"
import script from "./ScrapList.vue?vue&type=script&lang=js"
export * from "./ScrapList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports